import { CanDeactivateFn } from '@angular/router';

interface CompanyEditPendingChangesHost {
  canDeactivate: () => boolean | Promise<boolean>;
}

export const companyEditPendingChangesGuard: CanDeactivateFn<CompanyEditPendingChangesHost> = (
  component
) => {
  if (!component || typeof component.canDeactivate !== 'function') {
    throw new Error(
      'CompanyEditPendingChangesGuard requires component.canDeactivate() implementation.'
    );
  }

  return component.canDeactivate();
};
